"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9027],{

/***/ 99027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LiveCollaboration": function() { return /* binding */ LiveCollaboration; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75833);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prismic_reactjs__WEBPACK_IMPORTED_MODULE_1__);



const LiveCollaboration = (param)=>/*#__PURE__*/ {
    let { title , text1 , text2 , id  } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        className: "product-design__live-collaboration live-collaboration",
        id: id,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
            className: "product-design__live-collaboration-wrapper",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
                    className: "product-design__live-collaboration-wrapper-content",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("h4", {
                            className: "live-collaboration__title",
                            children: prismic_reactjs__WEBPACK_IMPORTED_MODULE_1__.RichText.asText(title)
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("p", {
                            className: "live-collaboration__text live-collaboration__text--1",
                            children: prismic_reactjs__WEBPACK_IMPORTED_MODULE_1__.RichText.asText(text1)
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("p", {
                            className: "live-collaboration__text live-collaboration__text--2",
                            children: prismic_reactjs__WEBPACK_IMPORTED_MODULE_1__.RichText.asText(text2)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
                    className: "product-design__our-design-process-collaboration-timeline-video",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("video", {
                        autoPlay: true,
                        loop: true,
                        preload: "auto",
                        muted: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("source", {
                            src: "/videos/how_we_collaborate.mp4",
                            type: "video/mp4"
                        })
                    })
                })
            ]
        })
    });
};


/***/ })

}]);